import React, { useRef } from 'react';
import { Box, Typography } from '@mui/material';
import { DraggerIcon, IconPencil, IconTrash } from '../../../../utils/icons';
import * as Reorder from '../../../../components/dnd/Reorder';

interface Props {
  index?: number;
  text: string;
  editText: () => void;
  removeText: () => void;
}

export function SingleLineEntry({ index, text, editText, removeText }: Props) {
  const containerRef = useRef(null);

  return (
    <Box
      ref={containerRef}
      className="flex gap-2 items-center justify-between p-3 sm:p-4 border border-border-token rounded-lg"
    >
      <Typography className="text-text-1 w-full min-w-0 break-words">
        {text}
      </Typography>
      {/* text-muted feeds the icons below via currentColor (SVG attrs can't take var()) */}
      <Box className="flex gap-1 sm:gap-2 items-center shrink-0 text-muted">
        <Box
          className="flex items-center justify-center cursor-pointer p-1"
          onClick={editText}
        >
          <IconPencil size={18} stroke="currentColor" />
        </Box>
        <Box
          className="flex items-center justify-center cursor-pointer p-1"
          onClick={removeText}
        >
          <IconTrash width={18} height={18} stroke="currentColor" />
        </Box>
        <Reorder.Trigger index={index!} containerRef={containerRef}>
          <Box className="flex items-center justify-center cursor-pointer">
            <DraggerIcon size={26} stroke="currentColor" />
          </Box>
        </Reorder.Trigger>
      </Box>
    </Box>
  );
}
